import { colors } from "@elit-hair/elit-tools";

import { splitPlate } from "@/helpers/strings";

const PlateComponent = ({ plate, className }: { plate: string; className?: string }) => {
    const formattedPlate = splitPlate(plate);
    return (
        <div className={`flex  max-w-fit  my-1   border rounded   border-slate-800  shadow ${className}`}>
            <div
                className={`w-5  flex shrink-0 items-end     justify-center grow-0 text-white font-medium text-[8px] leading-[15px] bg-[${colors.elitBlue}]`}
            >
                TR
            </div>
            <div className="font-semibold !min-w-[77.5px] flex items-center  p-1 grow text-black text-xs  whitespace-nowrap ">
                {formattedPlate}
            </div>
        </div>
    );
};

export default PlateComponent;
